import './course.page.css';
import TabBar from '../../component/tab-bar/tab-bar';
import React, { useEffect, useMemo, useState } from 'react';
import GeneralCoursePage from './general.course.page/general.course.page';
import ProgramCourseAssignmentsAndExams from './assignments-and-exams/program-course-assignments-and-exams';
import CourseLectures from './lectures/course-lectures';
import ProgramCoursePageStudentsTab from './students/program-course-page-students-tab';
import GradesCoursePage from './grades/grades.course.page';
import { CourseFeedbackTab } from './feedback/course-feedback-tab';
import globalCourseStore from '../../stores/global-course-store';
import { MenuItem } from 'primereact/menuitem';
import globalProgramStore from '../../stores/program-store';
import AppApi from '../../api/app-api';
import { useNavigate } from 'react-router-dom';
import appApi from '../../api/app-api';
import { ProgramYearsDistribution } from '../../api/types/programs/program.type';
import { Tooltip } from 'primereact/tooltip';
import { EditCourseNotesDialog } from './dialogs/edit-course-notes-dialog';
import { updateCourseNotesOperation } from './operations/update-course-notes-operation';

const tabs = [
  'כללי',
  'סטודנטים',
  'מפגשים',
  'מטלות ומבחנים',
  'משובי הוראה' /*, 'ציונים'*/,
];

interface ProgramCoursePageDatamodel {
  branchId: number;
  programId: number;
  courseId: number;
  isProfessor: boolean;
}
const ProgramCoursePage: React.FC<ProgramCoursePageDatamodel> = ({
  branchId,
  programId,
  courseId,
  isProfessor = false,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [showNotesDialog, setShowNotesDialog] = useState(false);
  const [notesInput, setNotesInput] = useState('');
  const [loadingNotes, setLoadingNotes] = useState(false);

  const navigate = useNavigate();

  const pages = [
    <GeneralCoursePage isProfessor={isProfessor} />,
    <ProgramCoursePageStudentsTab isProfessor={isProfessor} />,
    <CourseLectures isProfessor={isProfessor} />,
    <ProgramCourseAssignmentsAndExams isProfessor={isProfessor} />,
    <CourseFeedbackTab isProfessor={false} />,
    <GradesCoursePage />,
  ];
  const courseName = useMemo(() => {
    const currentCourse = globalCourseStore.getCurrentCourse();
    if (currentCourse) {
      return currentCourse.metadata.abstractData.courseName;
    }
    return '';
  }, [globalCourseStore.getCurrentCourse()]);

  const additionalCourseName = useMemo(() => {
    const currentCourse = globalCourseStore.getCurrentCourse();
    if (currentCourse) {
      return currentCourse.metadata.additionalCourseName;
    }
    return '';
  }, [globalCourseStore.getCurrentCourse()]);

  const currentProgram = globalProgramStore.programs.get(programId);

  const handleUpdateNotes = async () => {
    const currentCourse = globalCourseStore.getCurrentCourse();
    if (!currentCourse) return;

    await updateCourseNotesOperation(
      programId,
      courseId,
      notesInput,
      setLoadingNotes,
    );
    setShowNotesDialog(false);
  };

  //const courseId = 4;
  const breadItems: MenuItem[] = [
    { label: 'תוכניות', url: '/programs' },
    {
      label: `${currentProgram?.metadata.programName ?? ''} (${programId})`,
      url: '/programs/' + globalProgramStore.getCurrentId(),
    },
    { label: 'קורסים', url: `/programs/${programId}/courses/${courseId}` },
    {
      label: `${courseName} (${courseId})`,
      url: `/programs/${programId}/courses/${courseId}`,
    },
  ];
  const home: MenuItem = { icon: 'pi pi-home', url: '/' };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const programDetailsRes = await appApi.getProgramDetails(
          branchId,
          programId,
        );

        const programData = programDetailsRes.data
          .body as ProgramYearsDistribution;

        // Store the program data
        globalProgramStore.programs.set(programId, programData);
        globalProgramStore.currentId = programId;

        const res = await AppApi.getCourseDetails(programId, courseId);
        globalCourseStore.addCourseMetadata(res.data.body.metadata);

        globalCourseStore.addCourseDetails(courseId, res.data.body.details);
        globalCourseStore.currentId = courseId;
      } catch (e) {
        console.error(`Loading course details is failed with the error: ${e}`);
        navigate('/');
      }
      setIsLoading(false);
    };

    fetchData();
  }, []);

  return (
    <div className={'services-settings-body-page'}>
      <div className={'studies-settings-title'}>
        {[`קורס ${courseName}`, additionalCourseName]
          .filter(Boolean)
          .join(' - ')}
      </div>

      {/* Notes Section */}
      <div
        style={{
          marginTop: '16px',
          marginBottom: '16px',
          padding: '12px',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          border: '1px solid #e0e0e0',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <div style={{ flex: 1 }}>
            <div
              style={{
                color: '#6A6A6A',
                fontSize: '14px',
                fontWeight: 'bold',
                marginBottom: '8px',
              }}
            >
              הערות:
            </div>
            <div
              style={{
                color: '#404040',
                fontSize: '14px',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
              }}
            >
              {globalCourseStore.getCurrentCourse()?.metadata?.notes ||
                'אין הערות'}
            </div>
          </div>
          <div>
            <i
              className="pi pi-pencil edit-course-notes-btn"
              style={{
                fontSize: '14px',
                color: '#6A6A6A',
                cursor: 'pointer',
                marginRight: '8px',
              }}
              onClick={() => {
                setNotesInput(
                  globalCourseStore.getCurrentCourse()?.metadata?.notes || '',
                );
                setShowNotesDialog(true);
              }}
            />
            <Tooltip target=".edit-course-notes-btn" content="עריכת הערות" />
          </div>
        </div>
      </div>

      <TabBar
        disable={isLoading}
        tabs={tabs}
        onClick={(index) => {
          setSelectedIndex(index);
        }}
      ></TabBar>
      <br />
      {/*<Breadcrumb
        onClick={(index) => {
          return;
        }}
        crumbs={['הגדרות מערכת', 'שרותים']}
      ></Breadcrumb>
      <br />*/}

      {pages[selectedIndex]}

      <EditCourseNotesDialog
        visible={showNotesDialog}
        onHide={() => setShowNotesDialog(false)}
        notes={notesInput}
        onNotesChange={setNotesInput}
        onApprove={handleUpdateNotes}
        loading={loadingNotes}
      />
    </div>
  );
};

export default ProgramCoursePage;
